import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C6C6D6",
      d: "M11.333 2H4.667A2.667 2.667 0 0 0 2 4.667v4a2.667 2.667 0 0 0 2.667 2.666H6.5l.3 2.623c.267.355.8.355 1.067 0L9.5 11.333h1.833A2.667 2.667 0 0 0 14 8.667v-4A2.667 2.667 0 0 0 11.333 2"
    }, null, -1)
  ])))
}
export default { render: render }